import avatar1 from './streamer_avatar1.png';
import avatar2 from './streamer_avatar2.png';
import avatar3 from './streamer_avatar3.png';
import avatar4 from './streamer_avatar4.png';
import avatar5 from './streamer_avatar5.png';
import avatar6 from './streamer_avatar6.png';
import avatar7 from './streamer_avatar7.png';
import avatar8 from './streamer_avatar8.png';
import avatar9 from './streamer_avatar9.png';
import avatar10 from './streamer_avatar10.png';
import avatar11 from './streamer_avatar11.png';
import avatar12 from './streamer_avatar12.png';
import avatar13 from './streamer_avatar13.png';
import avatar14 from './streamer_avatar14.png';
import avatar15 from './streamer_avatar15.png';
import avatar16 from './streamer_avatar16.png';
import avatar17 from './streamer_avatar17.png';
import avatar18 from './streamer_avatar18.png';
import avatar19 from './streamer_avatar19.png';

const avatars = {
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    avatar10,
    avatar11,
    avatar12,
    avatar13,
    avatar14,
    avatar15,
    avatar16,
    avatar17,
    avatar18,
    avatar19,
}

export default avatars;